module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-a13b8155.woff2";